import React from 'react';

import { Container, LbPagination } from '@infoods/lifebase-ui';

import classes from './NgzReleases.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { EmptyList, PageTitle } from '../../../shared/components/ui-components';

import { releasesList } from './NgzReleases.settings';
import { useReleasesList } from './hooks/useReleasesList';
import { TitleRow } from './TitleRow/TitleRow';
import { ReleaseRow } from './ReleaseRow/ReleaseRow';
import { FiltersRow } from './FiltersRow/FiltersRow';

const NgzReleases = () => {
  const {
    filters,
    visibleReleases,
    sortMethods,
    page,
    totalPages,
    totalElements,
    elementsPerPage,
    isFiltered,
    handleFiltersChange,
    handleReset,
    handlePageChange,
  } = useReleasesList(releasesList);

  return (
    <Container>
      <PageTitle title="Releases" />
      <div className={classes.releasesTable}>
        <TitleRow
          handleSort={sortMethods.handleSort}
          getIsSortedBy={sortMethods.getIsSortedBy}
          reset={sortMethods.reset}
        />
        <FiltersRow
          filters={filters}
          onFiltersChange={handleFiltersChange}
          onReset={handleReset}
        />
        {visibleReleases.map((release) => (
          <ReleaseRow key={release.releaseId} release={release} />
        ))}
      </div>
      <EmptyList
        show={!totalElements}
        isSearch={isFiltered}
        description="There are no releases"
      />
      <LbPagination
        count={totalPages}
        page={page}
        onChange={handlePageChange}
        totalElements={totalElements}
        elementsPerPage={elementsPerPage}
        variant="outBox"
      />
    </Container>
  );
};

angularizeWithProviders(NgzReleases, 'ngzReleases', {});

export { NgzReleases };
